import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/Button.js';
import { Modal } from '@/components/ui/Modal.js';

type Props = { open: boolean; onClose: () => void; verifyUrl: string; number: string };

/**
 * QR ni ekranda ko'rsatish.
 *
 * PDF dagi QR bilan AYNAN bir xil manzil kodlanadi — xodim telefonida
 * sinab ko'ra oladi va sertifikat egasiga ekrandan ham skanerlatishi
 * mumkin (qog'oz qo'lida bo'lmasa).
 *
 * `qrcode` kutubxonasi DINAMIK yuklanadi: u faqat shu oyna ochilganda
 * kerak va admin panelning asosiy to'plamini og'irlashtirmasligi kerak.
 */
export function CertificateQrModal({ open, onClose, verifyUrl, number }: Props) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!open) {
      setDataUrl(null);
      return;
    }
    let cancelled = false;

    void import('qrcode').then(async (module) => {
      const url = await module.default.toDataURL(verifyUrl, { width: 420, margin: 1 });
      if (!cancelled) setDataUrl(url);
    });

    return () => {
      cancelled = true;
    };
  }, [open, verifyUrl]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`QR — sertifikat ${number}`}
      description="Skanerlanganda saytdagi tekshirish sahifasi ochiladi."
      size="sm"
      footer={<Button onClick={onClose}>Yopish</Button>}
    >
      <div className="flex flex-col items-center gap-3">
        {dataUrl ? (
          <img src={dataUrl} alt={`Sertifikat ${number} QR kodi`} className="size-[260px]" />
        ) : (
          <div className="flex size-[260px] items-center justify-center text-sm text-n-600">
            Yuklanmoqda…
          </div>
        )}
        <code className="break-all text-center text-[12px] text-n-600">{verifyUrl}</code>
      </div>
    </Modal>
  );
}
